<template lang="pug">
v-container.report-info-director
  base-text-divider 回報資料
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 繳款者：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.displayName }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 匯款時間：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.transferDate | timestampFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 繳交總額：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.total }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 帳號後五碼：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.lastFiveNumber || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 銀行名稱：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.bankname || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 回報單id：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ report.temp.id }}
  base-text-divider 收據列表
  receipt-list-info(:receipts="receipts")
  v-layout
    v-flex.text-xs-center
      v-btn(
        color="indigo"
        outline
        @click="settleForm = true") 核對此單所有收據
  v-dialog(
    v-model="settleForm"
    fullscreen)
    receipt-settle-form(
      v-if="settleForm"
      :receipts="receipts"
      @cancel="settleForm = false"
      @submit-succeed="settleSucceed"
      @printed="settleForm = false")
</template>
<script>
import { db } from "@/firebase";
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import ReceiptItemChip from "@/components/core/ReceiptItemChip.vue";
import ReceiptListInfo from "@/components/ReceiptListInfo.vue";
import ReceiptSettleForm from "@/components/forms/ReceiptSettleForm.vue";

export default {
  name: "ReportInfoDirector",
  components: {
    BaseTextDivider,
    ReceiptItemChip,
    ReceiptListInfo,
    ReceiptSettleForm
  },
  props: {
    report: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      settleForm: false,
      receipts: []
    };
  },
  async mounted() {
    await this.updateReceipts();
  },
  methods: {
    async settleSucceed() {
      this.$emit("settle-succeed");
      this.settleForm = false;
    },
    async updateReceipts() {
      const receiptIdList = this.report.receipts;
      const receipts = [];

      const promiseList = [];
      receiptIdList.forEach(id => {
        promiseList.push(
          db
            .collection("receipts")
            .doc(id)
            .get()
            .then(doc => {
              const data = doc.data();
              data.id = doc.id;
              receipts.push(data);
            })
        );
      });

      await Promise.all(promiseList);

      this.receipts = receipts;
    }
  }
};
</script>
